export const PUBLIC_SITE_URL = "https://ittec-pm.com";

const buildUrl = (path) => `${PUBLIC_SITE_URL}${path}`;

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "ITTEC P&M",
  alternateName: "International Trade and Technologie Parts & Maintenance",
  url: PUBLIC_SITE_URL,
  logo: `${PUBLIC_SITE_URL}/img/logo.png`,
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+216-70-836-528",
      contactType: "customer service",
      areaServed: "TN",
      availableLanguage: ["fr", "ar"],
    },
    {
      "@type": "ContactPoint",
      telephone: "+216-70-836-528",
      contactType: "sales",
      areaServed: "TN",
      availableLanguage: ["fr", "ar"],
    },
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "50, Rue de l'artisanat, ZI Charguia II",
    addressLocality: "Tunis Carthage",
    postalCode: "2035",
    addressCountry: "TN",
  },
};

const makePageSchema = (page, type, extra = {}) => ({
  "@context": "https://schema.org",
  "@type": type,
  name: page.title,
  url: buildUrl(page.path),
  description: page.metaDescription,
  ...extra,
});

export const ___pages = [
  {
    slug: "about",
    path: "/a-propos",
    title: "A propos de nous",
    metaTitle:
      "A propos d'ITTEC P&M | Pieces techniques, maintenance et renovation",
    metaDescription:
      "Decouvrez ITTEC P&M, entreprise specialisee dans la renovation d'organes, les pieces de rechange techniques, la fourniture aeroportuaire et la formation maintenance en Tunisie.",
    schema: makePageSchema(
      {
        title: "A propos d'ITTEC P&M",
        path: "/a-propos",
        metaDescription:
          "Entreprise specialisee dans la renovation d'organes et la maintenance technique.",
      },
      "AboutPage",
      { mainEntity: organizationSchema }
    ),
    content: `
    <article class="publicPage publicPage-about">
      <section class="publicHero">
        <div class="publicHero-copy">
          <span class="publicEyebrow">A propos de nous</span>
          <h1 class="publicHero-title">International Trade and Technologie Parts &amp; Maintenance</h1>
          <p class="publicHero-text">
            ITTEC P&amp;M est une entreprise sp&eacute;cialis&eacute;e dans la r&eacute;novation d'organes et de composants de v&eacute;hicules.
            Notre atelier est d&eacute;di&eacute; &agrave; la remise en &eacute;tat de pi&egrave;ces essentielles, telles que les bo&icirc;tes de vitesses
            DRIVENTIC/VOITH &amp; EATON, les ralentisseurs hydrauliques DRIVENTIC/VOITH, ainsi que les compresseurs BOCK utilis&eacute;s dans les syst&egrave;mes
            de climatisation d'autocars EBERSP&Auml;CHER.
          </p>
          <div class="publicMiniStats">
            <div class="publicMiniStat">
              <strong>Atelier de r&eacute;novation</strong>
              <span>Remise en &eacute;tat de bo&icirc;tes, ralentisseurs et compresseurs de r&eacute;f&eacute;rence.</span>
            </div>
            <div class="publicMiniStat">
              <strong>Pi&egrave;ces de rechange</strong>
              <span>Composants de qualit&eacute; pour les besoins de r&eacute;paration, remplacement et am&eacute;lioration.</span>
            </div>
            <div class="publicMiniStat">
              <strong>Formation &amp; conseil</strong>
              <span>Un accompagnement terrain pour d&eacute;velopper les comp&eacute;tences et fiabiliser l'exploitation.</span>
            </div>
          </div>
        </div>
        <div class="publicHero-media">
          <img src="https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=900&h=720&fit=crop" alt="Equipe technique ITTEC P&amp;M dans un atelier de maintenance">
        </div>
      </section>

      <section class="publicHighlight">
        <div class="publicHighlight-card">
          <span class="publicEyebrow publicEyebrow-light">Notre engagement</span>
          <h2>Excellence et efficacite.</h2>
          <p>
            Chez ITTEC P&amp;M, nous sommes passionn&eacute;s par l'excellence et l'efficacit&eacute;. Faites-nous confiance pour tous vos besoins
            en mati&egrave;re de v&eacute;hicules et de composants automobiles.
          </p>
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Nos activites</span>
          <h2>Des services complets.</h2>
          <p>Chaque p&ocirc;le vient renforcer la fiabilit&eacute; de vos v&eacute;hicules, de vos composants et de vos &eacute;quipes.</p>
        </div>
        <div class="publicFeatureGrid">
          <article class="publicFeatureCard">
            <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800&h=500&fit=crop" alt="Atelier de renovation ITTEC P&amp;M">
            <div class="publicFeatureCard-body">
              <h3>Atelier de r&eacute;novation</h3>
              <p>Notre atelier est d&eacute;di&eacute; &agrave; la remise en &eacute;tat de composants essentiels pour assurer la continuit&eacute; de vos activit&eacute;s.</p>
            </div>
          </article>
          <article class="publicFeatureCard">
            <img src="https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=500&fit=crop" alt="Magasin de pieces de rechange">
            <div class="publicFeatureCard-body">
              <h3>Magasin de pi&egrave;ces de rechange</h3>
              <p>Nous disposons d'un magasin de pi&egrave;ces de rechange o&ugrave; vous pouvez trouver des composants de qualit&eacute; pour vos v&eacute;hicules.</p>
            </div>
          </article>
          <article class="publicFeatureCard">
            <img src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=500&fit=crop" alt="Formation et conseil technique">
            <div class="publicFeatureCard-body">
              <h3>Formation et conseil</h3>
              <p>Notre d&eacute;partement ITTEC P&amp;M FORMATION ET CONSEIL propose des services de formation et de conseil avec une salle &eacute;quip&eacute;e.</p>
            </div>
          </article>
          <article class="publicFeatureCard">
            <img src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&h=500&fit=crop" alt="Support SAV electronique et mecanique">
            <div class="publicFeatureCard-body">
              <h3>Support SAV</h3>
              <p>Notre &eacute;quipe SAV hautement qualifi&eacute;e est pr&ecirc;te &agrave; r&eacute;pondre &agrave; vos besoins en maintenance et support technique.</p>
            </div>
          </article>
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Presentation</span>
          <h2>Ce que nous mettons a votre disposition.</h2>
        </div>
        <div class="publicBulletGrid">
          <ul class="publicCheckList">
            <li>Bo&icirc;tes de vitesses DRIVENTIC/VOITH &amp; EATON</li>
            <li>Ralentisseurs hydrauliques DRIVENTIC/VOITH</li>
            <li>Compresseurs BOCK pour climatisation d'autocars EBERSP&Auml;CHER</li>
            <li>Pi&egrave;ces essentielles et composants de v&eacute;hicules</li>
          </ul>
          <ul class="publicCheckList">
            <li>Magasin de pi&egrave;ces de rechange pour r&eacute;parations et am&eacute;liorations</li>
            <li>Formation et conseil avec personnel consultant exp&eacute;riment&eacute;</li>
            <li>Salle de conf&eacute;rence &eacute;quip&eacute;e pour sessions interactives</li>
            <li>Equipe SAV pour maintenance et support technique qualifi&eacute;</li>
          </ul>
        </div>
      </section>

      <section class="publicSection publicTimelineWrap">
        <div class="publicSection-head">
          <span class="publicEyebrow">Parcours durable</span>
          <h2>Parcours durable.</h2>
          <p>Une trajectoire construite dans le temps autour de l'expertise technique, de la maintenance et du service aux professionnels.</p>
        </div>
        <div class="publicTimeline">
          <article class="publicTimeline-item">
            <div class="publicTimeline-badge">1975</div>
            <div class="publicTimeline-card">
              <h3>TUNISIE GESTION</h3>
              <p>Premi&egrave;re &eacute;tape du parcours durable de l'entreprise.</p>
            </div>
          </article>
          <article class="publicTimeline-item">
            <div class="publicTimeline-badge">1980</div>
            <div class="publicTimeline-card">
              <h3>ITTEC SYSTEMS</h3>
              <p>Structuration d'une offre technique plus sp&eacute;cialis&eacute;e.</p>
            </div>
          </article>
          <article class="publicTimeline-item">
            <div class="publicTimeline-badge">1996</div>
            <div class="publicTimeline-card">
              <h3>ITTEC P&amp;M</h3>
              <p>Naissance d'ITTEC P&amp;M avec une offre articul&eacute;e autour de la r&eacute;novation, des pi&egrave;ces et du support technique.</p>
            </div>
          </article>
        </div>
      </section>
    </article>
    `,
  },
  {
    slug: "services",
    path: "/nos-services",
    title: "Nos services",
    metaTitle:
      "Nos services | Pieces de rechange, fourniture aeroports et formation",
    metaDescription:
      "Explorez les services ITTEC P&M : pieces de rechange, fourniture aeroportuaire, formation et conseil pour les activites de maintenance, transport et infrastructure.",
    schema: makePageSchema(
      {
        title: "Nos services ITTEC P&M",
        path: "/nos-services",
        metaDescription:
          "Vue d'ensemble des services ITTEC P&M pour maintenance, pieces et formation.",
      },
      "Service",
      {
        provider: {
          "@type": "Organization",
          name: "ITTEC P&M",
          url: PUBLIC_SITE_URL,
        },
      }
    ),
    content: `
    <article class="publicPage publicPage-services">
      <section class="publicPageHeroCenter">
        <span class="publicEyebrow">Nos services</span>
        <h1>Services cibl&eacute;s.</h1>
        <p>
          ITTEC P&amp;M d&eacute;ploie une offre claire pour aider les exploitants, ateliers et responsables techniques &agrave; mieux piloter la maintenance,
          s&eacute;curiser les approvisionnements et organiser la mont&eacute;e en comp&eacute;tence des &eacute;quipes.
        </p>
      </section>

      <section class="publicFeatureGrid publicFeatureGrid-services">
        <article class="publicFeatureCard publicFeatureCard-link">
          <img src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800&h=520&fit=crop" alt="Pieces de rechange pour maintenance">
          <div class="publicFeatureCard-body">
            <h2>Pi&egrave;ces de rechange</h2>
            <p>Catalogue de r&eacute;f&eacute;rences, accompagnement au choix des composants et soutien aux interventions de maintenance.</p>
            <a class="publicButtonLink" href="/services/pieces-de-rechange">Voir le d&eacute;tail</a>
          </div>
        </article>
        <article class="publicFeatureCard publicFeatureCard-link">
          <img src="https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=800&h=520&fit=crop" alt="Fourniture aeroportuaire et balisage lumineux">
          <div class="publicFeatureCard-body">
            <h2>Fourniture A&eacute;roports</h2>
            <p>Fourniture, installation et mise en service d'&eacute;quipements techniques pour projets a&eacute;roportuaires et balisage lumineux.</p>
            <a class="publicButtonLink" href="/services/fourniture-aeroports">Voir le d&eacute;tail</a>
          </div>
        </article>
        <article class="publicFeatureCard publicFeatureCard-link">
          <img src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=520&fit=crop" alt="Formation et conseil pour maintenance">
          <div class="publicFeatureCard-body">
            <h2>Formation et Conseil</h2>
            <p>Formations m&eacute;tier, audit, accompagnement technique et conseil pour les activit&eacute;s de maintenance et d'exploitation.</p>
            <a class="publicButtonLink" href="/services/formation-et-conseil">Voir le d&eacute;tail</a>
          </div>
        </article>
      </section>

      <section class="publicHighlight">
        <div class="publicHighlight-card">
          <span class="publicEyebrow publicEyebrow-light">Notre methode</span>
          <h2>M&eacute;thode efficace.</h2>
          <p>
            Chaque prestation est pens&eacute;e pour apporter une r&eacute;ponse op&eacute;rationnelle : identification des r&eacute;f&eacute;rences, organisation du projet,
            mise en service, accompagnement terrain et transfert de comp&eacute;tences.
          </p>
        </div>
      </section>
    </article>
    `,
  },
  {
    slug: "service-parts",
    path: "/services/pieces-de-rechange",
    title: "Pieces de rechange",
    metaTitle:
      "Pieces de rechange techniques | Catalogue et accompagnement ITTEC P&M",
    metaDescription:
      "ITTEC P&M accompagne vos besoins en pieces de rechange techniques : references, composants, aide a l'identification, devis et support pour maintenance et reparation.",
    schema: makePageSchema(
      {
        title: "Pieces de rechange techniques",
        path: "/services/pieces-de-rechange",
        metaDescription:
          "Accompagnement ITTEC P&M pour l'identification et la fourniture de pieces de rechange techniques.",
      },
      "Service",
      {
        serviceType: "Pieces de rechange techniques",
        provider: {
          "@type": "Organization",
          name: "ITTEC P&M",
          url: PUBLIC_SITE_URL,
        },
      }
    ),
    content: `
    <article class="publicPage publicPage-service-detail">
      <section class="publicHero publicHero-reversed">
        <div class="publicHero-copy">
          <span class="publicEyebrow">Nos services</span>
          <h1 class="publicHero-title">Pi&egrave;ces ma&icirc;tris&eacute;es.</h1>
          <p class="publicHero-text">
            Notre catalogue public et notre accompagnement permettent de retrouver plus facilement les composants n&eacute;cessaires &agrave; vos op&eacute;rations de maintenance,
            de comparer les familles de produits et de pr&eacute;parer une demande de devis plus rapide.
          </p>
          <ul class="publicCheckList">
            <li>Identification des r&eacute;f&eacute;rences et des familles techniques</li>
            <li>Appui au devis pour maintenance, remplacement ou stock de s&eacute;curit&eacute;</li>
            <li>Orientation sur les composants de transmission, climatisation et organes techniques</li>
          </ul>
        </div>
        <div class="publicHero-media">
          <img src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=900&h=720&fit=crop" alt="Pieces de rechange et composants de maintenance">
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Applications</span>
          <h2>Gammes align&eacute;es.</h2>
        </div>
        <div class="publicBulletGrid">
          <ul class="publicCheckList">
            <li>Composants de climatisation et d'autocars</li>
            <li>R&eacute;f&eacute;rences li&eacute;es aux ralentisseurs et transmissions</li>
            <li>Organes techniques pour interventions de maintenance courante</li>
            <li>Pi&egrave;ces utiles aux ateliers et responsables achat</li>
          </ul>
          <ul class="publicCheckList">
            <li>Lecture plus simple des r&eacute;f&eacute;rences et d&eacute;signations</li>
            <li>Acc&egrave;s rapide au d&eacute;tail produit et &agrave; la demande de devis</li>
            <li>Appui &agrave; la comparaison entre familles et cat&eacute;gories</li>
            <li>Pr&eacute;paration des besoins pour maintenance pr&eacute;ventive ou corrective</li>
          </ul>
        </div>
      </section>

      <section class="publicCalloutRow">
        <div class="publicCallout">
          <h2>Besoin d'une r&eacute;f&eacute;rence pr&eacute;cise ?</h2>
          <p>Consultez le catalogue puis contactez-nous avec la d&eacute;signation, la famille produit ou la r&eacute;f&eacute;rence d&eacute;j&agrave; identifi&eacute;e.</p>
          <a class="publicButtonLink" href="/catalogue">Ouvrir le catalogue</a>
        </div>
      </section>
    </article>
    `,
  },
  {
    slug: "service-airports",
    path: "/services/fourniture-aeroports",
    title: "Fourniture Aeroports",
    metaTitle:
      "Fourniture Aeroports | Balisage lumineux, installation et mise en service",
    metaDescription:
      "ITTEC P&M propose des prestations de fourniture aeroportuaire : equipements, balisage lumineux, installation, mise en service et accompagnement technique.",
    schema: makePageSchema(
      {
        title: "Fourniture Aeroports",
        path: "/services/fourniture-aeroports",
        metaDescription:
          "Fourniture aeroportuaire, balisage lumineux et mise en service par ITTEC P&M.",
      },
      "Service",
      {
        serviceType: "Fourniture aeroportuaire",
        provider: {
          "@type": "Organization",
          name: "ITTEC P&M",
          url: PUBLIC_SITE_URL,
        },
      }
    ),
    content: `
    <article class="publicPage publicPage-service-detail">
      <section class="publicHero">
        <div class="publicHero-copy">
          <span class="publicEyebrow">Nos services</span>
          <h1 class="publicHero-title">Fourniture a&eacute;roportuaire.</h1>
          <p class="publicHero-text">
            Nous accompagnons les projets n&eacute;cessitant la fourniture d'&eacute;quipements techniques, l'installation et la mise en service dans l'environnement
            a&eacute;roportuaire, avec une attention particuli&egrave;re &agrave; la lisibilit&eacute; du besoin et &agrave; la coordination technique.
          </p>
          <div class="publicMiniStats">
            <div class="publicMiniStat">
              <strong>Fourniture</strong>
              <span>S&eacute;lection d'&eacute;quipements selon le p&eacute;rim&egrave;tre du projet.</span>
            </div>
            <div class="publicMiniStat">
              <strong>Installation</strong>
              <span>Accompagnement &agrave; la mise en place des solutions retenues.</span>
            </div>
            <div class="publicMiniStat">
              <strong>Mise en service</strong>
              <span>Support au d&eacute;marrage et au transfert vers l'exploitation.</span>
            </div>
          </div>
        </div>
        <div class="publicHero-media">
          <img src="https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=900&h=720&fit=crop" alt="Projet aeroportuaire et balisage lumineux">
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Prestations</span>
          <h2>Approche projet.</h2>
        </div>
        <div class="publicBulletGrid">
          <ul class="publicCheckList">
            <li>Analyse du besoin et qualification du p&eacute;rim&egrave;tre technique</li>
            <li>Fourniture d'&eacute;quipements pour balisage lumineux et infrastructure associ&eacute;e</li>
            <li>Coordination installation et mise en service</li>
          </ul>
          <ul class="publicCheckList">
            <li>Appui &agrave; la pr&eacute;paration des interventions</li>
            <li>Dialogue avec les &eacute;quipes exploitation, maintenance ou projet</li>
            <li>Vision claire des &eacute;tapes avant remise en service</li>
          </ul>
        </div>
      </section>

      <section class="publicHighlight">
        <div class="publicHighlight-card">
          <span class="publicEyebrow publicEyebrow-light">Pourquoi cette page ?</span>
          <h2>Activit&eacute; clarifi&eacute;e.</h2>
          <p>
            Cette sous-page apporte un contenu plus explicite pour le visiteur comme pour le r&eacute;f&eacute;rencement naturel, en valorisant clairement le balisage lumineux,
            la fourniture a&eacute;roportuaire et l'accompagnement &agrave; la mise en service.
          </p>
        </div>
      </section>
    </article>
    `,
  },
  {
    slug: "service-training",
    path: "/services/formation-et-conseil",
    title: "Formation et Conseil",
    metaTitle:
      "Formation et conseil | Audit, maintenance, securite et accompagnement",
    metaDescription:
      "ITTEC P&M propose des services de formation et conseil : audit maintenance, organisation d'atelier, securite, climatisation autocars et accompagnement des equipes techniques.",
    schema: makePageSchema(
      {
        title: "Formation et Conseil",
        path: "/services/formation-et-conseil",
        metaDescription:
          "Formation et conseil pour maintenance, organisation d'atelier et securite.",
      },
      "Service",
      {
        serviceType: "Formation et conseil technique",
        provider: {
          "@type": "Organization",
          name: "ITTEC P&M",
          url: PUBLIC_SITE_URL,
        },
      }
    ),
    content: `
    <article class="publicPage publicPage-service-detail">
      <section class="publicHero publicHero-reversed">
        <div class="publicHero-copy">
          <span class="publicEyebrow">Nos services</span>
          <h1 class="publicHero-title">Former et conseiller.</h1>
          <p class="publicHero-text">
            Au-del&agrave; de la fourniture, ITTEC P&amp;M accompagne les &eacute;quipes techniques avec des contenus de formation, de l'audit, du conseil et des interventions
            orient&eacute;es performance maintenance.
          </p>
          <ul class="publicCheckList">
            <li>Gestion des parcs roulants, d&eacute;p&ocirc;ts et ateliers</li>
            <li>Audit maintenance et diagnostic des besoins</li>
            <li>Techniques de pr&eacute;vention, s&eacute;curit&eacute; et innovations m&eacute;tier</li>
          </ul>
        </div>
        <div class="publicHero-media">
          <img src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=900&h=720&fit=crop" alt="Session de formation maintenance et conseil">
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Axes d'intervention</span>
          <h2>Offre terrain.</h2>
        </div>
        <div class="publicBulletGrid">
          <ul class="publicCheckList">
            <li>Diagnostic des besoins et plans de formation</li>
            <li>Audit de la fonction maintenance</li>
            <li>Organisation des ateliers et d&eacute;p&ocirc;ts</li>
            <li>Syst&egrave;mes de climatisation autocars</li>
          </ul>
          <ul class="publicCheckList">
            <li>Techniques de pr&eacute;vention et de s&eacute;curit&eacute;</li>
            <li>Innovation technologique dans l'industrie automobile</li>
            <li>Lubrification et analyse des huiles industrielles</li>
            <li>Conseil pour appels d'offres et structuration des besoins</li>
          </ul>
        </div>
      </section>

      <section class="publicCalloutRow">
        <div class="publicCallout">
          <h2>Vous cherchez une formation plus complète ?</h2>
          <p>Consultez notre page d&eacute;di&eacute;e pour d&eacute;couvrir le centre, les th&eacute;matiques et le positionnement p&eacute;dagogique.</p>
          <a class="publicButtonLink" href="/formations-et-conseils">Voir la page formation</a>
        </div>
      </section>
    </article>
    `,
  },
  {
    slug: "training",
    path: "/formations-et-conseils",
    title: "Formations et conseils",
    metaTitle:
      "Formation professionnelle et conseil maintenance | ITTEC P&M",
    metaDescription:
      "Centre prive de formation et conseil ITTEC P&M : gestion maintenance, audit, securite, climatisation autocars, accompagnement des equipes techniques et programmes metier.",
    schema: makePageSchema(
      {
        title: "Formation professionnelle et conseil",
        path: "/formations-et-conseils",
        metaDescription:
          "Programmes de formation professionnelle et conseil maintenance par ITTEC P&M.",
      },
      "EducationalOrganization",
      {
        provider: {
          "@type": "Organization",
          name: "ITTEC P&M",
          url: PUBLIC_SITE_URL,
        },
      }
    ),
    content: `
    <article class="publicPage publicPage-training">
      <section class="publicHero">
        <div class="publicHero-copy">
          <span class="publicEyebrow">Formation &amp; conseil</span>
          <h1 class="publicHero-title">Former vos &eacute;quipes.</h1>
          <p class="publicHero-text">
            ITTEC P&amp;M Formation et Conseil est un centre priv&eacute; de formation agr&eacute;&eacute; qui propose des contenus directement reli&eacute;s aux r&eacute;alit&eacute;s du terrain :
            organisation des ateliers, s&eacute;curit&eacute;, maintenance, innovation technique et accompagnement des &eacute;quipes.
          </p>
          <div class="publicMiniStats">
            <div class="publicMiniStat">
              <strong>Formation m&eacute;tier</strong>
              <span>Programmes orient&eacute;s exploitation, maintenance et organisation.</span>
            </div>
            <div class="publicMiniStat">
              <strong>Audit</strong>
              <span>Diagnostic des besoins et structuration des plans d'action.</span>
            </div>
            <div class="publicMiniStat">
              <strong>Conseil</strong>
              <span>Appui technique, cahiers des charges et accompagnement des projets.</span>
            </div>
          </div>
        </div>
        <div class="publicHero-media">
          <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=900&h=720&fit=crop" alt="Salle de formation ITTEC P&amp;M">
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Programmes</span>
          <h2>Th&egrave;mes terrain.</h2>
        </div>
        <div class="publicBulletGrid">
          <ul class="publicCheckList">
            <li>Gestion des parcs roulants</li>
            <li>Gestion des depots et ateliers pour maintenance</li>
            <li>Gestion de la fonction maintenance</li>
            <li>Recyclage et perfectionnement dans la conduite</li>
          </ul>
          <ul class="publicCheckList">
            <li>Techniques de prevention et de securite</li>
            <li>Innovations technologiques dans l'industrie automobile</li>
            <li>Systemes de climatisation autocars</li>
            <li>Lubrification et analyse des huiles industrielles</li>
          </ul>
        </div>
      </section>

      <section class="publicHighlight publicHighlight-split">
        <div class="publicHighlight-card">
          <span class="publicEyebrow publicEyebrow-light">Audit et conseil</span>
          <h2>Interventions utiles.</h2>
          <ul class="publicCheckList publicCheckList-light">
            <li>Audit energetique</li>
            <li>Audit de la fonction maintenance</li>
            <li>Elaboration de cahiers des charges pour appels d'offres</li>
            <li>Diagnostic des besoins et plans de formation</li>
            <li>Recrutement et accompagnement des profils operationnels</li>
          </ul>
        </div>
        <div class="publicHighlight-card publicHighlight-card-alt">
          <span class="publicEyebrow publicEyebrow-light">Moyens mobilises</span>
          <h2>Approche humaine.</h2>
          <p>
            L'activite s'appuie sur une salle de formation, un environnement d'atelier et une equipe composee d'ingenieurs, de professeurs et de techniciens specialises.
          </p>
          <p>
            Les contenus sont construits pour etre directement exploitables par les equipes terrain, les managers de maintenance et les exploitants.
          </p>
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Beneficiaires</span>
          <h2>Structures form&eacute;es.</h2>
          <p>Cette experience nourrit des programmes plus concrets, plus utiles et plus adaptes aux contraintes d'exploitation.</p>
        </div>
        <div class="publicLogoCloud">
          <span>TRANSTU</span>
          <span>SRT BIZERTE</span>
          <span>SRT BEJA</span>
          <span>SRT JENDOUBA</span>
          <span>SORETRAK</span>
          <span>SRTG NABEUL</span>
          <span>TCV</span>
          <span>TTS</span>
          <span>CPG</span>
          <span>STTPM</span>
          <span>STAM</span>
          <span>GCT</span>
          <span>STEG</span>
        </div>
      </section>
    </article>
    `,
  },
  {
    slug: "contact",
    path: "/contact",
    title: "Contact",
    metaTitle: "Contact ITTEC P&M | Adresse, telephone et informations utiles",
    metaDescription:
      "Contactez ITTEC P&M pour vos demandes de pieces, prestations techniques, projets aeroportuaires ou formation. Adresse, telephone, horaires et localisation.",
    schema: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contact ITTEC P&M",
      url: buildUrl("/contact"),
      description:
        "Coordonnees et informations de contact d'ITTEC P&M.",
      mainEntity: {
        "@type": "LocalBusiness",
        name: "ITTEC P&M",
        telephone: "+216-70-836-528",
        address: organizationSchema.address,
        url: PUBLIC_SITE_URL,
      },
    },
    content: `
    <article class="publicPage publicPage-contact">
      <section class="publicPageHeroCenter">
        <span class="publicEyebrow">Contact</span>
        <h1>Nos coordonnées.</h1>
        <p>
          ITTEC P&amp;M reste &agrave; votre disposition pour vos demandes de pi&egrave;ces de rechange, de r&eacute;novation, de formation, de maintenance et de support technique.
        </p>
      </section>

      <section class="publicContactGrid">
        <div class="publicMapCard">
          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3192.46571966654!2d10.204535976298317!3d36.855269864592636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1sfr!2stn!4v1709166157916!5m2!1sfr!2stn" width="100%" height="420" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <div class="publicContactPanel">
          <div class="publicContactCard">
            <span class="publicEyebrow">Adresse bureau</span>
            <h2>Nos adresses</h2>
            <p>50, Rue de l&rsquo;artisanat, ZI Charguia II<br>2035 Tunis Carthage &ndash; Tunisie</p>
          </div>
          <div class="publicContactCard">
            <span class="publicEyebrow">Adresse atelier</span>
            <p>1, Rue de l&rsquo;usine, ZI Charguia II<br>2035 Tunis Carthage &ndash; Tunisie</p>
          </div>
          <div class="publicContactCard">
            <span class="publicEyebrow">Telephone</span>
            <p><a href="tel:+21670836528">(+216) 70 836 528</a></p>
            <p>Fax : (+216) 70 836 936</p>
          </div>
          <div class="publicContactCard">
            <span class="publicEyebrow">Horaires</span>
            <p>Lundi &ndash; Vendredi : 8H - 16H30</p>
          </div>
        </div>
      </section>

      <section class="publicSection">
        <div class="publicSection-head">
          <span class="publicEyebrow">Support</span>
          <h2>Comment nous joindre plus efficacement.</h2>
        </div>
        <div class="publicBulletGrid">
          <ul class="publicCheckList">
            <li>Pr&eacute;cisez la r&eacute;f&eacute;rence ou la d&eacute;signation du composant si vous l'avez d&eacute;j&agrave;.</li>
            <li>D&eacute;crivez votre besoin : r&eacute;paration, r&eacute;novation, formation ou support technique.</li>
            <li>Indiquez le contexte d'utilisation pour orienter rapidement votre demande vers le bon interlocuteur.</li>
          </ul>
          <ul class="publicCheckList">
            <li>Notre &eacute;quipe SAV hautement qualifi&eacute;e est pr&ecirc;te &agrave; vous accompagner.</li>
            <li>Notre d&eacute;partement Formation et Conseil peut &eacute;galement traiter vos besoins en comp&eacute;tences techniques.</li>
            <li>Nous sommes l&agrave; pour garantir le bon fonctionnement de vos organes et composants de v&eacute;hicules.</li>
          </ul>
        </div>
      </section>
    </article>
    `,
  },
];

export const PUBLIC_PAGE_MAP = ___pages.reduce((acc, page) => {
  acc[page.slug] = page;
  return acc;
}, {});

export const PUBLIC_CATALOG_META = {
  public: true,
  title: "Catalogue pieces de rechange | ITTEC P&M",
  description:
    "Consultez le catalogue public ITTEC P&M pour identifier vos pieces, references et composants techniques puis envoyer votre demande de devis.",
  canonical: buildUrl("/catalogue"),
  robots: "index, follow, max-image-preview:large",
  schema: {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Catalogue pieces de rechange ITTEC P&M",
    url: buildUrl("/catalogue"),
    description:
      "Catalogue public ITTEC P&M pour les pieces et composants techniques.",
    isPartOf: {
      "@type": "WebSite",
      name: "ITTEC P&M",
      url: PUBLIC_SITE_URL,
    },
  },
};

export const NO_INDEX_META = {
  public: false,
  robots: "noindex, nofollow",
};

export function getPublicPageMeta(slug) {
  const page = PUBLIC_PAGE_MAP[slug];

  if (!page) {
    return {
      public: true,
      title: "ITTEC P&M",
      description: "ITTEC P&M",
      canonical: PUBLIC_SITE_URL,
      robots: "index, follow, max-image-preview:large",
      schema: organizationSchema,
    };
  }

  return {
    public: true,
    title: page.metaTitle,
    description: page.metaDescription,
    canonical: buildUrl(page.path),
    robots: "index, follow, max-image-preview:large",
    schema: page.schema,
  };
}
